// CustomTooltip.js
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

export const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    '& .MuiTooltip-tooltip': {
        backgroundColor: 'white',
        border: 'none',
        boxShadow: '5px 5px 5px 5px gray',
        padding: '10px',
        maxWidth: '600px',
        // overflow: 'auto'
    },
    '& .MuiTooltip-arrow': {
        color: 'white',
    },
});

export const CustomTooltipBlack = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    '& .MuiTooltip-tooltip': {
        backgroundColor: 'white',
        border: 'none',
        boxShadow: '5px 5px 5px 5px gray',
        padding: '10px',
        maxWidth: '600px',
        color: 'black'
        // overflow: 'auto'
    },
    '& .MuiTooltip-arrow': {
        color: 'black',
    },
});

export default CustomTooltip;
